export const GET_ADMINS_REQUEST = "GET_ADMINS_REQUEST";
export const GET_ADMINS_RESPONSE = "GET_ADMINS_RESPONSE";

export const ADD_ADMIN_REQUEST = "ADD_ADMIN_REQUEST";

export const EDIT_ADMIN_REQUEST = "EDIT_ADMIN_REQUEST";

export const GET_ADMIN_DETAILS_REQUEST = "GET_ADMIN_DETAILS_REQUEST";
export const GET_ADMIN_DETAILS_RESPONSE = "GET_ADMIN_DETAILS_RESPONSE";

export const DELETE_ADMIN_REQUEST = "DELETE_ADMIN_REQUEST";
